export default __webpack_public_path__ + "static/breadcrumbs-current-item-dont-dark-ace896fb83548bf7b16f8750a8d8e217.png";